// src/components/TermsBanner.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./TermsBanner.css";

const TermsBanner = () => {
  return (
    <section className="terms-banner">
      <Container>
        <Row className="align-items-center">
          <Col md={12} className="text-content">
            <h2 className="banner-title">Terms & Conditions</h2>
            <p className="breadcrumb">
              Home <span> » </span> <span className="active">Terms & Conditions</span>
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TermsBanner;
